import { FC } from 'react';
import EmptyPlaceholder from '@orientaction/commons/EmptyPlaceholder';
import classNames from 'classnames';

// Styles inline temporaires
const useStyles = {
  root: {
    backgroundColor: '#fff',
    color: '#9799B1',
    width: '100%',
    marginTop: 10,
    boxSizing: 'border-box' as const,
  },
  error: {
    border: '2px solid #f44336',
  },
};

interface IProps {
  hasError?: boolean;
}

const NoRecommendedTest: FC<IProps> = ({ hasError = false }) => {
  const classes = useStyles;
  const combinedStyles = hasError ? {...classes.root, ...classes.error} : classes.root;
  return (
    <div style={combinedStyles}>
      <p style={{ textAlign: 'center', padding: '20px', margin: 0 }}>
        Aucun test recommandé
      </p>
    </div>
  );
};

export default NoRecommendedTest; 